const destinations = [
  { name: "Brazil & Latin America", context: "Peanut and cotton export trade missions; agribusiness buyer visits; mission trips from Dothan churches", urgency: "Trade delegations often organized with 2–4 weeks notice when market windows open", icon: "ri-map-pin-2-line" },
  { name: "Germany", context: "Fort Novosel allied training exchange programs; agribusiness technology conferences; manufacturing sector travel", urgency: "PCS orders and allied exchange programs arrive with compressed timelines", icon: "ri-map-pin-2-line" },
  { name: "South Korea", context: "Fort Novosel-Osan Air Base joint training; allied Korean aviation student families; export market visits", urgency: "Military family dependent passports must be current for overseas assignments", icon: "ri-map-pin-2-line" },
  { name: "Honduras & Central America", context: "Wiregrass church mission trips to Honduras, Guatemala, Belize; medical missions from SAMC physicians", urgency: "Mission trip departures are non-negotiable — last-minute participant additions happen regularly", icon: "ri-map-pin-2-line" },
  { name: "Southeast Asia", context: "Peanut export markets in Vietnam and Indonesia; church mission trips; Fort Novosel exchange programs", urgency: "Agricultural trade windows and mission trip seasons align in late winter and spring", icon: "ri-map-pin-2-line" },
  { name: "Caribbean", context: "Family beach vacations from Dothan connecting through Atlanta; military family leisure travel from Fort Novosel", urgency: "Last-minute summer vacation bookings are common in the military family community", icon: "ri-map-pin-2-line" },
];

const stats = [
  { stat: "3.5 hrs", label: "to Atlanta Hartsfield-Jackson — the international gateway for nearly all Dothan travelers" },
  { stat: "60+ Countries", label: "where Wiregrass mission teams and agribusiness exporters travel annually from Dothan" },
  { stat: "30 Days", label: "typical notice Fort Novosel families have after PCS orders arrive — dependent passports must be ready" },
  { stat: "Jan–Mar", label: "peak season when mission trip registrations and spring trade mission planning create passport urgencies" },
];

export default function DothanDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Dothan Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Wiregrass clients. Understanding Dothan's agribusiness, military, and faith community travel culture helps us catch issues before they derail a trade mission or mission trip departure.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Alabama Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">We serve travelers across Alabama with the same expedited passport processing and document review expertise.</p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              {[{ name: "Birmingham", href: "/birmingham" }, { name: "Montgomery", href: "/montgomery-al" }, { name: "Mobile", href: "/mobile-al" }].map((link) => (
                <a key={link.href} href={link.href} className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                  {link.name} <i className="ri-arrow-right-line text-xs"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}